import { Box, Flex, Spinner, Text, Image, Grid } from '@chakra-ui/react'
import { getVehicleInformationItems, VinOnlineVehicleDto } from 'BrokerTsLib/src/dtos'
import { useMemo } from 'react'
import car from '../assets/images/icons/car.svg'
import { useGetBrandLogo } from '../hooks/useDocuments'

export interface VehicleInformationItemProps {
  label: string
  value: string
}

interface VehicleInformationProps {
  vehicle: VinOnlineVehicleDto
  error?: string
}

const VehicleInformationItem = ({ label, value }: VehicleInformationItemProps) => {
  return (
    <Flex>
      <Text sx={{ fontWeight: 'bold' }}>
        {label}:{' '}
      </Text>
      <Text>{value}</Text>
    </Flex>
  )
}

export const VehicleInformation = ({ vehicle, error }: VehicleInformationProps) => {
  const items = useMemo(() => getVehicleInformationItems(vehicle ?? {}) as Array<VehicleInformationItemProps>, [vehicle])
  const itemsCount = items ? items.filter(x => x.value).length : 0

  const { data, isLoading, isError } = useGetBrandLogo(vehicle.CategoryID, vehicle.MakeBase, { retry: false })

  return (
    <Grid w='full' gap={8}
      gridTemplateColumns={{ base: '1fr', md: 'auto 9rem', lg: '1fr', xl: 'auto 9rem' }}
      gridTemplateRows={{ base: 'auto 9rem', md: 'auto', lg: 'auto 9rem', xl: 'auto' }}>
      <Box sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        rowGap: 1,
        columnGap: 10,
        gridTemplateRows: {
          base: `repeat(${(itemsCount)}, 1fr)`,
          md: `repeat(${(itemsCount / 2)}, 1fr)`
        }
      }}>
        {items &&
          itemsCount > 0 &&
          items.filter(x => x.value).map((item) => {
            return <VehicleInformationItem key={item.label} label={item.label} value={item.value} />
          })}

      </Box>
      {error && <Text variant={'danger'} textAlign='center'>{error}</Text>}

      <Box alignContent='center' justifySelf='center' px={{ xl: 4 }}>
        {!isLoading && !isError && data?.data &&
          <Image
            src={"data:image/png;base64," + data?.data}
            alt={vehicle.MakeBase}
            w={{ base: 'auto', md: 'full', lg: 'auto', xl: 'full' }}
            h={{ base: 'full', md: 'auto', lg: 'full', xl: 'auto' }}
          />
        }
      </Box>
    </Grid>
  )
}